import * as React from "react";
import { useEffect } from "react";
import { useAzureMaps } from "react-azure-maps";
import { ResourceType } from "azure-maps-control";

interface MapGlyphFixerProps {
    detail?: boolean;
}


// The default Azure Maps style references "SegoeFrutigerHelveticaMYingHei-*" glyphs
// (adds CJK character support) for label layers. That glyph range is not reachable
// with CORS from our domains, so every tile with text retries and fails forever.
// We don't need CJK glyphs, so redirect those requests to the plain Segoe UI glyphs.
// Azure only hosts a fixed set of SegoeUi weights, so unknown weight suffixes
// (e.g. "Medium", which doesn't exist as SegoeUi-Medium) fall back to Regular
// instead of producing a 404.
const VALID_SEGOE_UI_WEIGHTS = new Set(['Bold', 'Light', 'Regular', 'SemiBold', 'SemiLight', 'SymbolRegular']);

export const transformMapRequest = (url: string, resourceType: ResourceType) => {
    if (resourceType === 'Glyphs' && url.indexOf('MYingHei') >= 0) {
        const match = url.match(/SegoeFrutigerHelveticaMYingHei-([A-Za-z]+)/);
        const weight = match && VALID_SEGOE_UI_WEIGHTS.has(match[1]) ? match[1] : 'Regular';
        return { url: url.replace(/SegoeFrutigerHelveticaMYingHei-[A-Za-z]+/g, `SegoeUi-${weight}`) };
    }
    return { url };
};

export const MapGlyphFixer: React.FC<MapGlyphFixerProps> = ({ detail }) => {
    const { mapRef } = useAzureMaps();
    const windowKey = detail ? '__azureMapDetailRef' : '__azureMapRef';

    useEffect(() => {
        if (!mapRef) return;

        const onReady = () => {
            try { mapRef.resize(); } catch (e) {}
        };

        (window as any)[windowKey] = mapRef;
        mapRef.events.add('ready', onReady);
        return function() {
            mapRef.events.remove('ready', onReady);
            delete (window as any)[windowKey];
        };
    }, [mapRef]);

    return null;
};
